import {View, Text} from 'react-native';
import React from 'react';

export default function Divider() {
  return <View style={{width: '100%', marginTop: 8}} />;
}
